/* eslint-disable react-refresh/only-export-components */
import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const ContentListPage = lazy(() => import('./pages/list/ContentListPage'))
const ContentDetailPage = lazy(() => import('./pages/detail/ContentDetailPage'))

export const contenutiRoutes: RouteObject[] = [
  {
    path: 'contenuti',
    element: <ContentListPage />,
  },
  {
   path: '/contenuti/new',
    element: <ContentDetailPage  />,
  },
  {
    path: 'contenuti/:contentId',
    element: <ContentDetailPage />,
  },
]
